module.exports = __webpack_public_path__ + "img/04o-Shop_651.e7bd5bf5.jpg";